import Vue from 'vue';

const Success = (title: string, text: string, position: any = 'center-right') =>
  ShowMessage(title, text, 'success', true, false, position);

const Warning = (title: string, text: string, position: any = 'center-right') =>
  ShowMessage(title, text, 'warning', true, true, position);

const Error = (title: string, text: string, position: any = 'center-right') =>
  ShowMessage(title, text, 'error', false, true, position);

const Info = (title: string, text: string, position: any = 'center-right') =>
  ShowMessage(title, text, 'info', true, true, position);

const ShowMessage = (
  title: string,
  text: string,
  type: any,
  toast: boolean,
  showConfirmButton: boolean,
  position:
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'top-left'
    | 'top-right'
    | 'center'
    | 'center-start'
    | 'center-end'
    | 'center-left'
    | 'center-right'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'bottom-left'
    | 'bottom-right' = 'center-right',
) =>
  Vue.swal({
    title,
    text,
    timer: 4000,
    toast,
    position,
    showConfirmButton,
    type,
  });

export const MessageService = {
  Success,
  Warning,
  Error,
  Info,
};
